<script setup>

    import { ref, watchEffect } from 'vue';
    import { getFromAPI, getFullUrl } from '../../functionCollection';

    const props = defineProps(['fetchUrl', 'userNumber', 'isAdmin']);
    defineEmits(['switch-to-edit']);

    const paymentInfo = ref(null);

    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        paymentInfo.value = await getFromAPI(url);
        if (paymentInfo.value.IBAN) {
            paymentInfo.value.IBAN = formatIBAN(paymentInfo.value.IBAN);
        }
    })

    // format the stored IBAN in 4-char blocks for display.
    function formatIBAN(iban) {
        return iban.match(/.{1,4}/g).join(' ');
    }

</script>

<template>
    <div id="paymentform">
        <div class="well">
            <div class="row">
                <div class="column" v-if="paymentInfo">
                    <p>Nachfolgend sind Ihre Bankdaten, wenn zutreffend/vorhanden.</p>
                    <p v-if="paymentInfo.Zahlart === 'Bankeinzug'">
                        <strong>{{ paymentInfo.Zahlart }}</strong><br>
                        Kontonummer endet auf: ...{{ paymentInfo.Kontonummer }}<br>
                        BLZ: {{ paymentInfo.BLZ }}<br>
                        Bank: {{ paymentInfo.Bank }}<br>
                    </p>
                    <p v-if="paymentInfo.Zahlart === 'SEPA-Basislastschrift (CORE)'">
                        <strong>{{ paymentInfo.Zahlart }}</strong><br>
                        IBAN: {{ paymentInfo.IBAN }}<br>
                        BIC: {{ paymentInfo.BIC }}<br>
                        <div v-if="isAdmin">
                            Mandatsreferenz: {{ paymentInfo.Mandatsreferenz }}<br>
                            Mandatsdatum: {{ paymentInfo.Mandatsdatum }}<br>
                        </div>
                        <small><em>Zum besseren Schutz Ihrer Daten wird die IBAN verkürzt angedruckt.</em></small>
                    </p>
                    <p v-if="paymentInfo.Zahlart != 'SEPA-Basislastschrift (CORE)' && paymentInfo.Zahlart != 'Bankeinzug'">
                        {{ paymentInfo.Zahlart }}
                    </p>
                </div>
            </div>

            <div class="table-footer right">
                <button
                    class="btn btn-link footer-button"
                    @click="$emit('switch-to-edit')">
                    Bearbeiten <i class="fas fa-lg fa-pencil-alt"></i>
                </button>
            </div>
        </div>
    </div>
</template>
